import { RegionStore, Web3Store } from '@vatom/sdk/core'
import { Instance, SnapshotOut, types } from 'mobx-state-tree'

export const SolanaRegionStore = RegionStore.named('SolanaRegionStore').props({
  api: types.optional(Web3Store, {})
})

export type SolanaRegionStoreType = Instance<typeof SolanaRegionStore>
export type SolanaRegionStoreSnapshot = SnapshotOut<typeof SolanaRegionStore>
